import { StatAmountUsd } from '@ui/components/Stats';
import { useMarketPrice } from '@ui/features/Trade/hooks/useMarketPrice';
import { useTradingPair } from '@ui/features/Trade/store/useTradingPair';
import { useTokenDisplayDecimals } from '@ui/hooks/useTokenDisplayDecimals';
import { Box } from 'styled-system/jsx';

export const TokenPrice = () => {
  const tradingPair = useTradingPair((s) => s.useTradingPair());
  const marketPrice = useMarketPrice();
  const priceDisplayDecimals = useTokenDisplayDecimals(
    tradingPair.baseSymbol,
    tradingPair.priceDisplayDecimals,
  );

  return (
    <Box>
      {/* V2: price is white mono — tick-flash only, never statically coloured */}
      <StatAmountUsd
        textStyle="numbers.large"
        fontSize="18px"
        fontWeight="500"
        color="v2.text.primary"
        value={marketPrice}
        opts={{
          displayDecimals: priceDisplayDecimals,
        }}
        data-cy={`TokenPrice-${tradingPair.pairName}`}
        data-cy-value={marketPrice}
      />
    </Box>
  );
};
